type GetFormattedDateBlogCard = {
  date: string;
};

export const getFormattedDateBlogCard = ({
  date,
}: GetFormattedDateBlogCard) => {
  const initialDate = new Date(date);
  const options = { month: "short", day: "numeric" } as {
    month: "short" | "numeric" | "2-digit" | "long" | "narrow";
    day: "numeric" | "2-digit";
  };
  const formattedDate = initialDate.toLocaleDateString("en-US", options);
  const currentDate = new Date();

  if (initialDate.getFullYear() < currentDate.getFullYear()) {
    return `${formattedDate} ${initialDate.getFullYear()}`;
  }

  return formattedDate;
};
